import styled from "styled-components";
import Typography from "@8x8/oxygen-typography";

export const JobDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;

  /* Need to be a specific height, cannot be left auto or 100% */
  height: 72vh;

  overflow: hidden;
`;

export const JobDetailsSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  overflow: hidden;
  padding: 8px 0;
  border-bottom: 1px solid #eee;

  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const SectionTitle = styled(Typography).attrs({
  size: "md",
  weight: "attention",
})`
  margin-top: 0;
  margin-bottom: 8px;
`;

export const ScrollableContent = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  // Setting min-height: 0 is often necessary for flex items
  // to shrink below their content size.
  min-height: 0;
`;
